import React, { Component } from 'react';
import _ from 'lodash';
import ListOfFleets from '../../components/FleetManager/FleetDetails/ListOfFleets';
import FleetManagerService from '../../services/FleetManagerService';
import { downlodFile } from '../../utils/utils';
class FleetDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      totalVehiclesTyres: [],
      fleetsTotalVehiclesTyres: {},
      isLoading: false
    };
  }

  componentDidMount() {
    // this.getTotalVehiclesAndTyres();
    // this.getFleetsTotalVehiclesAndTyres({ query: '', page: 1, pagesize: 10, isActive: true });
  }

  getTotalVehiclesAndTyres = async () => {
    let { totalVehiclesTyres } = this.state;
    try {
      const { data } = await FleetManagerService.getTotalVehiclesAndTyres();
      if (data && data.data) {
        totalVehiclesTyres = data.data;
      }

      this.setState({ totalVehiclesTyres });
    }
    catch (error) {
      console.log(error);
    }
  }

  getFleetsTotalVehiclesAndTyres = async (q) => {
    let { fleetsTotalVehiclesTyres, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await FleetManagerService.getTotalVehiclesAndTyresByFleet(q);
      isLoading = false;
      if (q.downloadReport === true) {
        downlodFile(data.data.file);
        this.setState({ isLoading: false });

        return;
      }
      this.setState({ isLoading });
      if (data && data.data) {
        fleetsTotalVehiclesTyres = data.data;
        fleetsTotalVehiclesTyres.pageCount = Math.trunc(fleetsTotalVehiclesTyres.total_element / 10) + 1;
        fleetsTotalVehiclesTyres.page = q.page;

        _.forEach(fleetsTotalVehiclesTyres.fleet_data, (fleet) => {
          fleet.modifiedData = {};
          _.forEach(fleet.data, (d) => {
            fleet.modifiedData[`${d.type}TotalVehicles`] = d.total_vehicle;
            fleet.modifiedData[`${d.type}TotalTyres`] = d.total_tyre;
          });
        });
      }
      this.setState({ fleetsTotalVehiclesTyres });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
      console.log(error);
    }
  }

  handlePageClick = (e) => {
    this.getFleetsTotalVehiclesAndTyres({ query: '', page: e.selected + 1, pagesize: 10 });
  }

  render() {
    const { totalVehiclesTyres, fleetsTotalVehiclesTyres } = this.state;

    return (
      <div>
        {/* {isLoading && <CustomSpinner />} */}
        <ListOfFleets totalVehiclesTyres={totalVehiclesTyres} fleetsTotalVehiclesTyres={fleetsTotalVehiclesTyres} handlePageClick={this.handlePageClick} getFleetsTotalVehiclesAndTyres={this.getFleetsTotalVehiclesAndTyres} />
      </div>
    );
  }
}

export default FleetDetails;
